<template>
  <div class="py-4 text-center text-black bg-light">
    <div class="container">
      <div class="col-md-12"><h1>Submit your application</h1></div>
      <div class="col-md-12">
        <p></p>
        <p>
          We are always looking for bright minds and enthusiastic people from
          diverse backgrounds, who want to be part of an outstanding team. Even
          if you don’t find a suitable position below, please do not hesitate to
          drop us your resume.
        </p>
        <p></p>
      </div>
      <div class="col-md-12">
        <router-link
          :to="{ name: 'jobapply_notid'}"
          role="button"
          class="btn btn-lg bg-primary-color text-white"
        >
          Apply now
        </router-link>
        <!-- <a
          href="/cclick/apply"
          role="button"
          aria-disabled="true"
          class="btn btn-lg bg-primary-color text-white"
        >
          Apply now
        </a> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return{

        }
    }
};
</script>

<style scoped>
.btn-group-lg>.btn, .btn-lg {
    padding: 0.5rem 1rem;
    font-size: 1.25rem;
    line-height: 1.5;
    border-radius: 0.3rem;
}


.btn-lg:hover {
  background-color: #1041a5 !important;
  border-color: #1041a5 !important;
}

.btn-apply,
.btn-apply:hover {
  background-color: #1041a5 !important;
  border-color: #1041a5 !important;
}
.bg-primary-color {
    background-color: #1041A5;
}
.text-white {
    color: #fff!important;
}
.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.bg-primary-color {
    background-color: #1041A5;
}
</style>